export const WORKFROMHOME = '0035';
export const WORKFROMOFFICE = '0036';
export const WORKFROMCLIENT = '0037';

const WORKMODES = {
  HOME: WORKFROMHOME,
  OFFICE: WORKFROMOFFICE,
  CLIENT: WORKFROMCLIENT
};

export {WORKMODES};
